import { type BreadcrumbItem, type NavigationFromState, buildDynamicBreadcrumbs } from '@vizit/utils';
import { workspaceRoute } from '../../workspace-routes';
import { LIBRARY_BREADCRUMB, getLibraryBreadcrumb } from './constants';

/**
 * The crumbs above a benchmark page: Collections (the Library's Collections tab) and Benchmarks (its Benchmarks
 * view). `benchmarksSearch` restores the Benchmarks view's filters when following the crumb back.
 */
export function getBenchmarksBreadcrumbTrail(
  workspaceSlug: string | undefined,
  benchmarksSearch: Record<string, unknown> = {},
): BreadcrumbItem[] {
  return [
    { ...getLibraryBreadcrumb('collections'), search: { view: 'collections' } },
    {
      label: 'Benchmarks',
      // Workspace-scoped already, so it does not pick up the Library icon the flat `/library` crumb gets.
      href: workspaceSlug ? workspaceRoute(workspaceSlug, '/library') : '/library',
      search: { view: 'collections', collectionsView: 'benchmarks', ...benchmarksSearch },
    },
  ];
}

/**
 * The benchmark page's breadcrumbs: the trail it was opened with, or Collections › Benchmarks when it was opened
 * directly, then the benchmark name as the current crumb.
 */
export function buildBenchmarkBreadcrumbs(
  from: NavigationFromState | undefined,
  workspaceSlug: string,
  benchmarkName: string,
  currentSearch?: Record<string, unknown>,
): BreadcrumbItem[] {
  const trail = from?.trail?.length ? from : { trail: getBenchmarksBreadcrumbTrail(workspaceSlug) };
  return buildDynamicBreadcrumbs(trail, benchmarkName, undefined, currentSearch, LIBRARY_BREADCRUMB);
}
